import { useBooleanState } from '@cian/react-utils';
import { IconChevronDownSmall16, IconChevronUpSmall16 } from '@cian/ui-kit';

import { useListingContext } from 'shared/context/ListingContext';
import { ISeoLinkSchema } from 'shared/repositories/commercial-search-offers/entities/seo_link/SeoLinkSchema';
import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';
import { memoWithDisplayName } from 'shared/utils/memoWithDisplayName';

import { QuickLinks } from './QuickLinks';
import { QuickLinksMoreItemsButtonProps } from './internal/components/QuickLinksMoreItemsButton';
import { trackQuickLinkClick, trackQuickLinkMoreButtonClick } from './internal/tracking';

export const QuickLinksContainer = memoWithDisplayName(() => {
  const {
    seo: {
      view: { links },
    },
  } = useListingContext();

  const { state: expanded, setTrue: setExpanded, setFalse: setCollapsed } = useBooleanState();

  const isShort = useListingLayoutIsShortSelector();

  if (!links.length) {
    return null;
  }

  const quickLinksList = ((): ISeoLinkSchema[] => {
    if (isShort && !expanded) {
      return links.slice(0, 3);
    }

    return links;
  })();

  const diff = links.length - quickLinksList.length;
  const columns = isShort ? 2 : 3;

  const moreItemsButton = ((): QuickLinksMoreItemsButtonProps | null => {
    if (diff > 0) {
      return {
        dataTestId: 'quick-links-more-button',
        icon: <IconChevronDownSmall16 color="primary_100" />,
        onClick(): void {
          trackQuickLinkMoreButtonClick();
          setExpanded();
        },
        title: `Ещё ${diff}`,
      };
    }

    if (isShort && expanded) {
      return {
        dataTestId: 'quick-links-less-button',
        icon: <IconChevronUpSmall16 color="primary_100" />,
        onClick(): void {
          // Не трекаем сворачивание - требование аналитиков
          setCollapsed();
        },
        title: 'Свернуть',
      };
    }

    return null;
  })();

  return (
    <QuickLinks
      columns={columns}
      moreItemsButton={moreItemsButton}
      quickLinks={quickLinksList}
      trackQuickLinkClick={trackQuickLinkClick}
    />
  );
}, 'QuickLinksContainer');
